<template>
	<v-navigation-drawer
		color="primary"
		width="200"
		persistent
		permanent
		app>
		<v-toolbar flat class="transparent">
			<v-list class="pa-5">
				<v-list-item class="white--text">
					<v-list-item-action>
						<v-img :src="logo.src" :max-width="width"></v-img>
					</v-list-item-action>
				</v-list-item>
			</v-list>
		</v-toolbar>
		<v-divider></v-divider>
		<v-list dark dense>
			<v-subheader class="mt-3 pl-3 text-uppercase white--text text--darken-1">
				{{ $t('menu.api-gateway') }}
			</v-subheader>
			<v-list>
				<v-list-item v-for="item in gateway" :key="item.text" :to="item.link">
					<v-list-item-action class="pl-3">
						<v-icon>{{ item.icon }}</v-icon>
					</v-list-item-action>
					<v-list-item-title v-text="item.text"></v-list-item-title>
				</v-list-item>
			</v-list>
			<v-subheader class="mt-3 pl-3 text-uppercase white--text text--darken-1">
				{{ $t('menu.user-management') }}
			</v-subheader>
			<v-list>
				<v-list-item v-for="item in userManagement" :key="item.text" :to="item.link">
					<v-list-item-action class="pl-3">
						<v-icon>{{ item.icon }}</v-icon>
					</v-list-item-action>
					<v-list-item-title v-text="item.text"></v-list-item-title>
				</v-list-item>
			</v-list>
		</v-list>
		<template v-slot:append>
			<v-list-item @click="signOut">
				<v-list-item-action class="pl-3">
					<v-icon color="white darken-1">logout</v-icon>
				</v-list-item-action>
				<v-list-item-title class="white--text text--darken-1">{{ $t('menu.logout') }}</v-list-item-title>
			</v-list-item>
		</template>
	</v-navigation-drawer>
</template>

<script>
import { mapActions } from 'vuex';
import rmdyAuth, { AUTH_ACTIONS } from '@rmdy/rmdy-authentication-frontend';

export default {
	name: 'AppSidebar',
	data() {
		return {
			width: '100px',
			route: '',
			logo: { src: require('@/assets/logo.png') },
			gateway: [
				{ icon: 'device_hub', text: this.$t('menu.projects'), link: '/projects' },
			],
			userManagement: [
				{ icon: 'admin_panel_settings', text: this.$t('menu.roles'), link: '/roles' },
				{ icon: 'groups', text: this.$t('menu.groups'), link: '/groups' },
				{ icon: 'account_circle', text: this.$t('menu.users'), link: '/users' },
			],
		};
	},
	methods: {
		...mapActions({
			logout: `${rmdyAuth.moduleName}/${AUTH_ACTIONS.LOGOUT}`,
		}),
		signOut() {
			this.logout();
			this.$router.push('/login');
		}
	},
};
</script>

<style lang="scss" scoped>
@import "@/styles/colors.scss";

.active-route {
	background-color: $navigation-grey;
}
</style>
